module.exports = __webpack_public_path__ + "images/577191e58e77c83db355c7d980b4f338.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro/intro_logo@2x.png
// module id = 584
// module chunks = 24